/** Settings and their dashboard aliases share the billing navigation entry. */
export function isSettingsRoute(pathname: string): boolean {
  return ['/settings', '/dashboard/settings', '/sell/settings'].some(
    (root) => pathname === root || pathname.startsWith(`${root}/`),
  );
}
